import { PropertyTypeNames } from '../../../system/property-type';

export const TOTAL_STEPS = 7;
export const STEP_DONE = 'STEP_DONE';

const GradientBlue =
  'linear-gradient(214deg, #FCFCFB 17%, #EFF2FF 60.21%, #C9D2FF 109.63%)';
const GradientOrange =
  'linear-gradient(214deg, #FCFCFB 17%, #FFF4EF 60.21%, #FFDBC9 109.63%)';
const GradientMint =
  'linear-gradient(214deg, #FCFCFB 17%, #DBF6F2 60.21%, #86E2D5 109.63%)';

export const BACKGROUND_GRADIENTS = {
  [PropertyTypeNames.BUSINESS_OPPORTUNITY]: GradientBlue,
  [PropertyTypeNames.COMMERCIAL_LEASE]: GradientBlue,
  [PropertyTypeNames.COMMERCIAL_SALE]: GradientBlue,
  [PropertyTypeNames.FARM]: GradientMint,
  [PropertyTypeNames.LAND]: GradientMint,
  [PropertyTypeNames.LAND_AND_LOTS]: GradientMint,
  [PropertyTypeNames.MULTI_FAMILY]: GradientOrange,
  [PropertyTypeNames.RESIDENTIAL]: GradientBlue,
  [PropertyTypeNames.RESIDENTIAL_INCOME]: GradientOrange,
  [PropertyTypeNames.RESIDENTIAL_LEASE]: GradientOrange,
} as const;
